module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("Fun and fearless ideas for role play.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("Steamy and sensual ways to build intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("Embark on an exciting journey into the sensual realm.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("Dress—and undress—for sexy success.")])]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6d.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("How to make your fantasies come true.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("All the most satisfying sex positions.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p7a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("Hands-on hints for teasing and pleasing.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p7b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("Sweetly sizzling make-out moments.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p7c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "gallery_text"
  }, [_vm._v("Seductive secrets and saucy games.")])])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b43d9994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fmpart2.vue
// module id = 69
// module chunks = 0